export enum ProductListType {
  Normal = 'normal',
  Commercial = 'commercial',
  Power = 'power',
}
